import { Spin } from 'antd';

export const LoadingState = () => (
  <div style={{ textAlign: 'center', padding: '50px' }}>
    <Spin size="large" />
  </div>
);
